// quick-view.js — swatches, Vista Rápida y back-to-top (autónomo, sin dependencias del bundle)
(function () {
  'use strict';

  // --- Helpers de carrito (reutilizan el mini-cart existente) ---
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (res) {
      return res.text().then(function (body) {
        var data = null;
        try { data = body ? JSON.parse(body) : null; } catch (e) { data = null; }
        if (!res.ok) {
          throw new Error((data && data.description) || 'No se pudo añadir al carrito');
        }
        return data;
      });
    });
  }
  function openMiniCart() {
    var mc = document.querySelector('.mini-cart--shop');
    if (mc) mc.classList.add('visible'); // dispara fetchCart() del mini-cart (MutationObserver)
  }
  // Abre el mini-cart YA (antes de que responda /cart/add.js, que es lento) mostrando un skeleton
  function openMiniCartLoading() {
    openMiniCart();
    document.dispatchEvent(new CustomEvent('cart:adding'));
  }
  // Reemplaza una línea del carrito por otra variante conservando la cantidad.
  // Añade la nueva variante primero (nunca dejamos el carrito con menos de lo que había)
  // y luego elimina la vieja. Preserva Samita B2B (usa los mismos endpoints AJAX del tema).
  function replaceVariant(oldVariantId, newVariantId, quantity) {
    if (String(oldVariantId) === String(newVariantId)) return Promise.resolve();
    return addToCart(newVariantId, quantity).then(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: oldVariantId, quantity: 0 })
      }).then(function (r) { if (!r.ok) throw new Error('No se pudo reemplazar'); return r.json(); });
    });
  }
  // Avisa a mini-cart y a la página de carrito para que refresquen su vista.
  function notifyCartRefresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  // --- Módulo: Vista Rápida (modal) ---
  var QV = {
    root: null,
    lastFocus: null,
    open: function (handle, card, opts) {
      opts = opts || {};
      QV.replaceCtx = opts.replace || null; // { oldVariantId, quantity } cuando editamos un ítem del carrito
      QV.openToken = (QV.openToken || 0) + 1;
      var token = QV.openToken;
      QV.lastFocus = document.activeElement;
      QV.root = document.getElementById('quick-view-root');
      QV.root.innerHTML = '<div class="qv-overlay" data-qv-overlay><div class="qv-modal" role="dialog" aria-modal="true" aria-label="Vista rápida del producto"><div class="qv-modal__loading">Cargando…</div></div></div>';
      QV.root.classList.add('is-open');
      QV.root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      QV.bindDismiss();
      var preselect = opts.preselectVariantId || (card ? card.dataset.qvActiveVariant : null);
      fetch('/products/' + handle + '?section_id=quick-view')
        .then(function (res) { if (!res.ok) throw new Error('fetch'); return res.text(); })
        .then(function (html) {
          if (token !== QV.openToken) return; // apertura obsoleta (cerrada o reabierta)
          var modalEl = QV.root && QV.root.querySelector('.qv-modal');
          if (!modalEl) return;
          modalEl.innerHTML = html;
          QV.wire(preselect);
        })
        .catch(function () {
          if (token === QV.openToken) { window.location.href = '/products/' + handle; }
        });
    },
    close: function () {
      document.removeEventListener('keydown', QV.onKey);
      QV.openToken = (QV.openToken || 0) + 1;
      if (!QV.root) return;
      QV.root.classList.remove('is-open');
      QV.root.setAttribute('aria-hidden', 'true');
      if (QV._swiper) { try { QV._swiper.destroy(true, true); } catch (e) { } QV._swiper = null; }
      QV.root.innerHTML = '';
      // Si el mini-cart sigue abierto detrás del modal, no liberar el scroll del body.
      if (!document.querySelector('.mini-cart--shop.visible')) {
        document.body.classList.remove('overflow-hidden');
      }
      if (QV.lastFocus) QV.lastFocus.focus();
      QV.root = null;
    },
    bindDismiss: function () {
      QV.root.querySelector('[data-qv-overlay]').addEventListener('click', function (e) {
        if (e.target === e.currentTarget) QV.close();
      });
      document.addEventListener('keydown', QV.onKey);
    },
    onKey: function (e) { if (e.key === 'Escape') QV.close(); },
    wire: function (preselectVariantId) {
      var modal = QV.root.querySelector('[data-qv-modal-product]');
      if (!modal) return;
      var variantsEl = modal.querySelector('[data-qv-variants]');
      var variants = JSON.parse((variantsEl && variantsEl.textContent) || '[]');
      var main = modal.querySelector('[data-qv-gallery-main]');
      var priceEl = modal.querySelector('[data-qv-price]');
      var addBtn = modal.querySelector('[data-qv-add]');
      var selected = {}; // position -> value

      modal.querySelector('[data-qv-close]').addEventListener('click', QV.close);

      // Inicializar selección con las opciones activas del render
      modal.querySelectorAll('[data-qv-value].is-active').forEach(function (el) {
        selected[el.dataset.optionPosition] = el.dataset.value;
      });

      // Miniaturas de galería
      modal.querySelectorAll('[data-qv-gallery-thumbs] .qv-modal__thumb').forEach(function (t) {
        t.addEventListener('click', function () { if (main) main.src = t.dataset.image; });
      });

      // Galería deslizable en móvil (Swiper ya está cargado por el tema)
      if (window.matchMedia('(max-width: 768px)').matches && window.Swiper) {
        var thumbs = modal.querySelector('[data-qv-gallery-thumbs]');
        if (thumbs) {
          // Construir slides a partir de las miniaturas existentes
          var imgs = Array.prototype.map.call(thumbs.querySelectorAll('.qv-modal__thumb'), function (t) { return t.dataset.image; });
          if (imgs.length > 1) {
            var qvTitle = (modal.querySelector('.qv-modal__title') || {}).textContent || '';
            var wrap = document.createElement('div');
            wrap.className = 'swiper qv-modal__swiper';
            wrap.innerHTML = '<div class="swiper-wrapper">' + imgs.map(function (src) {
              return '<div class="swiper-slide"><img src="' + src + '" alt="' + qvTitle.replace(/"/g, '') + '" style="width:100%;object-fit:contain"></div>';
            }).join('') + '</div><div class="swiper-pagination"></div>';
            main.parentNode.insertBefore(wrap, main);
            main.style.display = 'none';
            thumbs.style.display = 'none';
            if (QV._swiper) { try { QV._swiper.destroy(true, true); } catch (e) { } QV._swiper = null; }
            QV._swiper = new window.Swiper(wrap, { pagination: { el: wrap.querySelector('.swiper-pagination') } });
            QV._swiperImgs = imgs; // para sincronizar con el color elegido
          }
        }
      }

      function findVariant() {
        return variants.find(function (v) {
          return Object.keys(selected).every(function (pos) {
            return v.options[parseInt(pos, 10) - 1] === selected[pos];
          });
        });
      }
      // Si el combo exacto no existe, resuelve a la 1a variante disponible que respete la opción tocada.
      function resolveVariant(changedPos) {
        var exact = findVariant();
        if (exact) return exact;
        var pool = variants.filter(function (v) {
          return changedPos == null || v.options[parseInt(changedPos, 10) - 1] === selected[changedPos];
        });
        if (!pool.length) pool = variants.slice();
        return pool.filter(function (v) { return v.available; })[0] || pool[0];
      }
      // Sincroniza selección + estado activo a la variante v.
      function syncSelectionTo(v) {
        modal.querySelectorAll('.qv-modal__values').forEach(function (group) {
          var els = group.querySelectorAll('[data-qv-value]');
          if (!els.length) return;
          var pos = els[0].dataset.optionPosition;
          var val = v.options[parseInt(pos, 10) - 1];
          selected[pos] = val;
          els.forEach(function (el) { el.classList.toggle('is-active', el.dataset.value === val); });
        });
      }
      // ¿Hay variante EN STOCK con (option[pos]=val) respetando las opciones previas elegidas?
      function isValueAvailable(pos, val) {
        pos = parseInt(pos, 10);
        return variants.some(function (v) {
          if (!v.available) return false;
          if (v.options[pos - 1] !== val) return false;
          for (var p = 1; p < pos; p++) {
            if (selected[p] != null && v.options[p - 1] !== selected[p]) return false;
          }
          return true;
        });
      }
      function updateAvailability() {
        modal.querySelectorAll('[data-qv-value]').forEach(function (el) {
          var ok = isValueAvailable(el.dataset.optionPosition, el.dataset.value);
          el.disabled = !ok;
          el.classList.toggle('qv-modal__value--unavailable', !ok);
        });
      }
      function refresh(changedPos) {
        var v = resolveVariant(changedPos);
        if (v) {
          syncSelectionTo(v);
          if (v.image && main) main.src = v.image;
          // Móvil: el main está oculto y el swiper es la galería visible.
          // Las imágenes de las variantes no siempre están entre las miniaturas, así que
          // mostramos la imagen de la variante en la 1a diapositiva y volvemos a ella.
          if (v.image && QV._swiper) {
            var base = v.image.split('?')[0];
            var idx = (QV._swiperImgs || []).map(function (s) { return s.split('?')[0]; }).indexOf(base);
            if (idx >= 0) {
              QV._swiper.slideTo(idx);
            } else {
              QV._swiper.slideTo(0);
              var slide0 = QV._swiper.slides && QV._swiper.slides[0];
              var img0 = slide0 && slide0.querySelector('img');
              if (img0) img0.src = v.image;
            }
          }
          addBtn.dataset.variantId = v.id;
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (QV.replaceCtx ? 'Reemplazar' : 'Añadir al carrito') : 'Agotado';
          priceEl.innerHTML = QV.money(v.price);
        } else {
          addBtn.disabled = true;
          addBtn.textContent = 'Selecciona una opción';
          delete addBtn.dataset.variantId;
        }
        updateAvailability();
      }

      modal.querySelectorAll('[data-qv-value]').forEach(function (el) {
        el.addEventListener('click', function () {
          if (el.disabled) return;
          var pos = el.dataset.optionPosition;
          selected[pos] = el.dataset.value;
          // marcar activo dentro del mismo grupo de opción
          el.closest('.qv-modal__values').querySelectorAll('[data-qv-value]').forEach(function (s) { s.classList.remove('is-active'); });
          el.classList.add('is-active');
          refresh(pos);
          // Efecto de atención en el botón al elegir talla/color
          if (window.pulseCTA && addBtn && !addBtn.disabled) window.pulseCTA(addBtn);
        });
      });

      // Cantidad
      var qtyInput = modal.querySelector('[data-qv-qty-input]');
      if (QV.replaceCtx && qtyInput) qtyInput.value = QV.replaceCtx.quantity || 1; // arranca con la cantidad de la línea
      modal.querySelector('[data-qv-qty-minus]').addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      });
      modal.querySelector('[data-qv-qty-plus]').addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      });

      // Preselección desde el swatch de la tarjeta
      if (preselectVariantId) {
        var pv = variants.find(function (v) { return String(v.id) === String(preselectVariantId); });
        if (pv) {
          modal.querySelectorAll('[data-qv-value]').forEach(function (el) {
            var pos0 = parseInt(el.dataset.optionPosition, 10) - 1;
            if (pv.options[pos0] === el.dataset.value) el.click();
          });
        }
      }

      // Añadir al carrito / Reemplazar desde el modal
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var variantId = addBtn.dataset.variantId;
        var qty = parseInt(qtyInput.value, 10) || 1;
        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        var original = addBtn.textContent;
        if (QV.replaceCtx) {
          // Modo edición: reemplazar la variante de la línea del carrito
          var ctx = QV.replaceCtx;
          addBtn.textContent = 'Reemplazando…';
          replaceVariant(ctx.oldVariantId, variantId, qty)
            .then(function () { QV.close(); notifyCartRefresh(); })
            .catch(function (err) {
              addBtn.textContent = err.message || 'No disponible';
              setTimeout(function () { addBtn.textContent = original; }, 2500);
            })
            .finally(function () { addBtn.classList.remove('is-loading'); addBtn.disabled = false; });
        } else {
          addBtn.textContent = 'Añadiendo…';
          QV.close();
          openMiniCartLoading(); // abre el carrito YA con skeleton mientras responde add.js
          addToCart(variantId, qty)
            .then(function () { notifyCartRefresh(); })
            .catch(function (err) {
              addBtn.textContent = err.message || 'No disponible';
              setTimeout(function () { addBtn.textContent = original; }, 2500);
            })
            .finally(function () { addBtn.classList.remove('is-loading'); addBtn.disabled = false; });
        }
      });

      refresh();
    },
    money: function (cents) {
      // Formato COP sin decimales, coherente con el tema (remove ',00')
      return '$ ' + (cents / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 });
    }
  };
  window.QuickView = QV;

  // --- Módulo: swatches (cambio de imagen en la tarjeta) ---
  function initSwatches() {
    document.querySelectorAll('[data-qv-swatches]').forEach(function (group) {
      var card = group.closest('[data-qv-card]');
      if (!card) return;
      var primary = card.querySelector('[data-qv-primary]');
      var hoverImg = card.querySelector('.product-article__figure--hover');
      var swatches = group.querySelectorAll('.qv-swatch:not(.qv-swatch--more)');
      swatches.forEach(function (sw) {
        function activate() {
          if (primary && sw.dataset.image) primary.src = sw.dataset.image;
          if (hoverImg && sw.dataset.image) hoverImg.src = sw.dataset.image;
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          card.dataset.qvActiveVariant = sw.dataset.variantId || '';
        }
        sw.addEventListener('mouseenter', activate);
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          activate();
          // Efecto de atención en el botón de agregar de la tarjeta al elegir color
          if (window.pulseCTA) window.pulseCTA(card.querySelector('[data-qv-smart-add]'));
        });
      });
    });
  }
  initSwatches();

  // --- Módulo: botón inteligente ---
  function initSmartAdd() {
    document.querySelectorAll('[data-qv-smart-add]').forEach(function (btn) {
      var card = btn.closest('[data-qv-card]');
      if (!card) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantsCount = parseInt(card.dataset.qvVariantsCount || '1', 10);
        var optionsCount = parseInt(card.dataset.qvOptionsCount || '1', 10);
        var hasSwatches = !!card.querySelector('[data-qv-swatches]');
        var handle = card.dataset.productHandle;

        // ¿Podemos resolver una variante concreta sin abrir el modal?
        var directVariant = null;
        if (variantsCount <= 1) {
          directVariant = card.dataset.qvFirstVariant;               // producto de 1 variante
        } else if (optionsCount === 1 && hasSwatches) {
          directVariant = card.dataset.qvActiveVariant || card.dataset.qvFirstVariant; // solo Color, resuelto por swatch
        }

        if (directVariant) {
          if (btn.dataset.qvBusy === '1') return;
          var variantId = directVariant;
          // Cantidad: si la tarjeta tiene un input de cantidad (vista lista), respetarla; si no, 1
          var qtyEl = card.querySelector('[data-qv-qty-card], .product-article-second__qty--number');
          var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
          var loader = btn.querySelector('.product-article__action--loader');
          var span = btn.querySelector('span');
          var originalText = span ? span.textContent : null;
          if (loader) loader.style.display = 'block';
          btn.dataset.qvBusy = '1';
          openMiniCartLoading(); // abre el carrito YA con skeleton mientras responde add.js
          addToCart(variantId, qty)
            .then(function () { notifyCartRefresh(); })
            .catch(function (err) {
              console.error('[quick-view]', err.message);
              if (span) {
                span.textContent = 'No disponible';
                setTimeout(function () { span.textContent = originalText; }, 2500);
              }
            })
            .finally(function () { if (loader) loader.style.display = 'none'; btn.dataset.qvBusy = ''; });
        } else {
          // Multi-opción, o 1 opción no-Color, o vista lista multi-variante: abrir Vista Rápida
          window.QuickView.open(handle, card);
        }
      });
    });
  }
  initSmartAdd();

  // --- Módulo: botón dedicado Vista Rápida ---
  document.querySelectorAll('[data-qv-quickview]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var card = b.closest('[data-qv-card]');
      if (card && window.QuickView) window.QuickView.open(card.dataset.productHandle, card);
    });
  });

  // --- Módulo: editar variante de un ítem del carrito (delegado; el carrito se re-renderiza) ---
  document.addEventListener('click', function (e) {
    var edit = e.target.closest('[data-qv-edit]');
    if (!edit) return;
    e.preventDefault();
    var handle = edit.getAttribute('data-qv-handle');
    if (!handle) return;
    window.QuickView.open(handle, null, {
      preselectVariantId: edit.getAttribute('data-qv-variant-id'),
      replace: {
        oldVariantId: edit.getAttribute('data-qv-variant-id'),
        quantity: parseInt(edit.getAttribute('data-qv-line-qty'), 10) || 1
      }
    });
  });

  // "+N" abre siempre la Vista Rápida
  document.querySelectorAll('[data-qv-more]').forEach(function (more) {
    more.addEventListener('click', function (e) {
      e.preventDefault();
      var card = more.closest('[data-qv-card]');
      window.QuickView.open(card.dataset.productHandle, card);
    });
  });

  // --- Módulo: volver arriba ---
  (function initBackToTop() {
    var btn = document.getElementById('qv-back-to-top');
    if (!btn) return;
    function onScroll() { btn.classList.toggle('is-visible', window.scrollY > 600); }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      var el = document.scrollingElement || document.documentElement;
      var prev = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto'; // el tema usa scroll-behavior:smooth global, que no aplica al scroll programatico aqui
      var start = el.scrollTop;
      var startTime = null;
      var duration = 400;
      function step(ts) {
        if (startTime === null) startTime = ts;
        var p = Math.min(1, (ts - startTime) / duration);
        el.scrollTop = Math.round(start * (1 - p * (2 - p))); // easeOutQuad
        if (p < 1) {
          requestAnimationFrame(step);
        } else {
          el.style.scrollBehavior = prev;
        }
      }
      requestAnimationFrame(step);
    });
    onScroll();
  })();
})();
